/**
 * NYC Containers: front-end enhancements.
 * Size selector: ARIA tabs (click, ←/→, Home/End). Without JS every panel stays visible.
 */
( function () {
	'use strict';

	function initScale( root ) {
		var tabs = Array.prototype.slice.call( root.querySelectorAll( '[role="tab"]' ) );
		var panels = tabs.map( function ( tab ) {
			return document.getElementById( tab.getAttribute( 'aria-controls' ) );
		} );

		root.classList.add( 'is-enhanced' );

		function select( index, focus ) {
			tabs.forEach( function ( tab, i ) {
				var on = i === index;
				tab.setAttribute( 'aria-selected', on ? 'true' : 'false' );
				tab.tabIndex = on ? 0 : -1;
				panels[ i ].hidden = ! on;
			} );
			if ( focus ) {
				tabs[ index ].focus();
			}
		}

		tabs.forEach( function ( tab, i ) {
			tab.addEventListener( 'click', function () {
				select( i, false );
			} );
			tab.addEventListener( 'keydown', function ( e ) {
				var next = null;
				if ( 'ArrowRight' === e.key ) {
					next = ( i + 1 ) % tabs.length;
				} else if ( 'ArrowLeft' === e.key ) {
					next = ( i - 1 + tabs.length ) % tabs.length;
				} else if ( 'Home' === e.key ) {
					next = 0;
				} else if ( 'End' === e.key ) {
					next = tabs.length - 1;
				}
				if ( null !== next ) {
					e.preventDefault();
					select( next, true );
				}
			} );
		} );

		var start = tabs.findIndex( function ( tab ) {
			return 'true' === tab.getAttribute( 'aria-selected' );
		} );
		select( start < 0 ? 0 : start, false );
	}

	/* Home catalogue: the New/Used dropdown shows one of three server-rendered grids. */
	function initCatalog( root ) {
		var select = root.querySelector( '[data-yc-catalog-select]' );
		var panels = root.querySelectorAll( '[data-yc-catalog-panel]' );
		if ( ! select ) {
			return;
		}
		select.addEventListener( 'change', function () {
			panels.forEach( function ( p ) {
				p.hidden = p.getAttribute( 'data-yc-catalog-panel' ) !== select.value;
			} );
		} );
	}

	/* Shop filters: apply on change (the Apply button remains for keyboard and no-JS users). */
	function initFilters( form ) {
		form.classList.add( 'is-auto' );
		form.addEventListener( 'change', function () {
			form.classList.add( 'is-loading' );
			form.submit();
		} );
	}

	/* Reviews: arrow buttons scroll the rail one card at a time. */
	function initReviews( root ) {
		var track = root.querySelector( '.yc-reviews__track' );
		var btns = root.querySelectorAll( '.yc-reviews__btn' );
		if ( ! track || btns.length < 2 ) {
			return;
		}
		function update() {
			btns[ 0 ].disabled = track.scrollLeft <= 2;
			btns[ 1 ].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
		}
		btns.forEach( function ( b ) {
			b.addEventListener( 'click', function () {
				var card = track.querySelector( '.yc-review' );
				var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
				track.scrollBy( { left: step * parseInt( b.getAttribute( 'data-dir' ), 10 ), behavior: 'smooth' } );
			} );
		} );
		track.addEventListener( 'scroll', update, { passive: true } );
		update();
	}

	/* "Read more" expands a clamped review. */
	function initReadMore() {
		document.addEventListener( 'click', function ( e ) {
			var b = e.target.closest( '.yc-review__more' );
			if ( ! b ) {
				return;
			}
			var open = b.closest( '.yc-review' ).classList.toggle( 'is-open' );
			b.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			b.textContent = open ? 'Show less' : 'Read more';
		} );
	}

	function init() {
		document.querySelectorAll( '[data-yc-reviews]' ).forEach( initReviews );
		initReadMore();
		document.querySelectorAll( '[data-yc-scale]' ).forEach( initScale );
		document.querySelectorAll( '[data-yc-catalog]' ).forEach( initCatalog );
		document.querySelectorAll( '[data-yc-filters]' ).forEach( initFilters );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
